import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CodeSnippetComponent } from '../../../../../components/common/code-snippet/code-snippet.component';

@Component({
  selector: 'app-recommendation-code-snippet',
  standalone: true,
  imports: [CodeSnippetComponent, CommonModule],
  templateUrl: './recommendation-code-snippet.component.html',
  styleUrl: './recommendation-code-snippet.component.scss'
})
export class RecommendationCodeSnippetComponent {
  @Input() data: any = {};
}
